var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99959 15.8333C4.99959 16.75 5.74959 17.5 6.66626 17.5H13.3329C14.2496 17.5 14.9996 16.75 14.9996 15.8333V5.83333H4.99959V15.8333ZM15.8329 3.33333H12.9163L12.0829 2.5H7.91626L7.08293 3.33333H4.16626V5H15.8329V3.33333Z",
    fill: "#F15B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.4c5242e880ee5df7d202afc22c3d4952.svg";
export { ForwardRef as ReactComponent };